<template lang="pug">
.d-contents
  portal(v-if="dialogId && context" :to="`${dialogId}.${$dialogs.slots.content}`")
    signature-account-setup(
      :context="context"
      :preview-context="signaturePreview"
      :dialog-id="dialogId"
      :is-active="isActive"
    )
</template>

<script>
import SignatureAccountSetup from '../Forms/SignatureAccountSetup.vue';
import { signatureSetup } from '../../services/signatureSetup';
import signaturePreviewContext from '../../services/signaturePreviewContext';

export default {
  mixins: [signaturePreviewContext],
  components: { SignatureAccountSetup },
  data: () => ({ dialogId: undefined, context: null, cancelled: false, closing: false }),
  computed: {
    setupState() { return this.signaturePreview ? this.signaturePreview.setup : signatureSetup; },
    pending() { return this.setupState.context; },
    userId() {
      if (this.signaturePreview) return this.pending?.previewUser?.id || null;
      return this.$user.isAuthenticated ? this.$user.data.id : null;
    },
  },
  watch: {
    pending: { handler: 'open', immediate: true },
    userId() {
      if (this.context && this.context.userId !== this.userId) this.cancel();
    },
    $route() { this.cancel(); },
  },
  beforeDestroy() { this.cancel(); },
  methods: {
    isActive() {
      if (!this.context || this.cancelled || this.closing || this.setupState.context !== this.context || !this.$dialogs.has(this.dialogId)) return false;
      if (this.signaturePreview) {
        return this.context.previewUser.id === this.context.userId && this.context.previewUser.organizer.id === this.context.organizationId;
      }
      return this.$user.isAuthenticated &&
        this.$user.data.id === this.context.userId && this.$user.data.organizer?.id === this.context.organizationId;
    },
    open(context) {
      if (!context || context.userId !== this.userId || (this.dialogId && this.$dialogs.has(this.dialogId))) return;
      this.context = context;
      this.cancelled = false;
      this.closing = false;
      this.dialogId = this.$dialogs.portal({
        attrs: { title: 'Настройте вход в личный кабинет', 'max-width': 640 },
        listeners: { close: this.release, 'click:outside': this.release, 'before:close': () => { this.closing = true; } },
      });
    },
    cancel() {
      this.cancelled = true;
      this.setupState.context = null;
      if (this.dialogId) this.$dialogs.close(this.dialogId);
    },
    release() {
      if (this.setupState.context === this.context) this.setupState.context = null;
      this.dialogId = undefined;
      this.context = null;
    },
  },
};
</script>
